<style lang="scss">
    @import "index";
</style>
<template>
    <el-dialog key="2"
               :lock-scroll="true" :append-to-body="true"
               :visible.sync="dialogVisible"
               center class="self-carousel"
               custom-class="self-carousel"
               top="40px">
        <div class="carousel-box">
            <slot name="top" :data="dataItem"></slot>
            <div class="self-carousel-body">
                <i v-if="data.length > 1" class="icon-arrow-left iconfont" @click="prev"></i>
                <div class="carousel-content">
                    <el-carousel arrow="never" ref="carousel" @change="onChange" v-if="dialogVisible"
                                 :autoplay="false"
                                 indicator-position="none"
                                 v-loading="loading"
                                 :initial-index="index"
                                 element-loading-text="正在生成预览图片..."
                                 element-loading-spinner="el-icon-loading">
                        <el-carousel-item v-for="(item, index) in data" :key="index" class="c-center c-vertical-align">
                            <img v-if="type === 'template'" :src="item.defaultUrl">
                            <img v-else :src="item.url"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <i v-if="data.length > 1" class="icon-arrow-right iconfont" @click="next"></i>
            </div>
            <slot name="bottom" :data="dataItem"></slot>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        props: {
            value: {type: Boolean ,default: false},
            data: {type: Array, default: null},
            index: {type: Number, default: 0},
            type: {type: String, default: ''},
            loading: {type: Boolean, default: false}
        },
        data () {
            return {
                dataItem: {json:{}},
            };
        },
        computed: {
            dialogVisible: {
                get () {
                    return this.value;
                },
                set (v) {
                    this.$emit('input', v);
                }
            }
        },
        watch: {
            dialogVisible:{
                handler(v){
                        if(!v) {
                            this.$emit('close');
                        } else if(this.data && this.data.length > 0){
                            this.onChange(this.index);
                        }
                },
                immediate: true
            }
        },
        methods: {
            prev () {
                this.$refs.carousel.prev();
                this.$emit('switch');
            },
            next () {
                this.$refs.carousel.next();
                this.$emit('switch');
            },
            onChange (index) {
                this.dataItem = this.data[index];
            }
        }
    }
</script>